var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-responsive bg-white rounded"},[_c('tasks',{staticClass:"m-4",attrs:{"scope":"ORGANIZATION"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }